import React from "react";
import ReactApexChart from "react-apexcharts";
import Card from "components/card";

const ReportLineGraph = ({ lineGraphInfo }) => {
  // Handle case where lineGraphInfo is not available or empty
  if (!lineGraphInfo || lineGraphInfo.length === 0)
    return <div>Loading...</div>;

  return (
    <div className="grid gap-5 md:grid-cols-2 grid-cols-1">
      {lineGraphInfo.map((config, index) => {
        // Prepare the data for ReactApexChart
        const options = {
          chart: {
            type: "line",
            height: 380,
            toolbar: { show: false },
          },
          stroke: { width: [3, 2], curve: "smooth" },
          fill: {
            type: ["solid", "gradient"], // Line and area
            gradient: {
              shadeIntensity: 1,
              opacityFrom: 0.7,
              opacityTo: 0.3,
              stops: [0, 90, 100],
            },
          },
          dataLabels: { enabled: false },
          markers: { size: 5 },
          xaxis: {
            categories: config.lineGraphInfo.timestamps,
            title: { text: "Timestamps" },
          },
          yaxis: [
            {
              title: { text: config.lineGraphInfo.datasets[0]?.yaxisLabel },
              labels: { style: { colors: "#008FFB" } },
            },
            {
              opposite: true,
              title: { text: config.lineGraphInfo.datasets[1]?.yaxisLabel },
              labels: { style: { colors: "#FEB019" } },
            },
          ],
          tooltip: {
            shared: true,
            intersect: false,
          },
          legend: { position: "top" },
        };

        const series = config.lineGraphInfo.datasets.map((dataset, i) => ({
          name: dataset.label,
          type: i === 0 ? "line" : "area",
          data: dataset.data,
        }));

        return (
          <Card key={index} extra="rounded-[20px] p-3 h-[450px] relative">
            <div className="flex flex-row justify-between px-3 pt-2">
              <h4 className="text-lg font-bold text-navy-700 dark:text-white">
                {config.plotName}
              </h4>
            </div>
            <div className="mb-auto flex h-[380px] w-full items-center justify-center">
              {config.plottype === "ReactAreaChart" && (
                <ReactApexChart
                  options={options}
                  series={series}
                  type="line"
                  height={380}
                  width={480}
                />
              )}
            </div>
          </Card>
        );
      })}
    </div>
  );
};

export default ReportLineGraph;
